// external
import { Box, LinearProgress } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useService from '../../../hooks/service.hook';
import useSnackbarHelper from '../../../hooks/snackbar.hook';
import DeviceRegistrationService from '../../../services/device-registration.service';

const CorosOAuthRedirectPage: FC = () => {
  const location = useLocation();
  const { showSnackbar } = useSnackbarHelper();
  const navigate = useNavigate();
  const deviceRegistrationService = useService(DeviceRegistrationService);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const errorCode = searchParams.get('error');
    const authorizationCode = searchParams.get('code');

    if (errorCode || !authorizationCode) {
      showSnackbar('There was an error while registering your COROS account. Please try again later', 'error');
      navigate('/profile');
    } else {
      deviceRegistrationService
        .registerCorosUser(authorizationCode)
        .then(() => {
          showSnackbar('Successfully linked COROS account', 'success');
          navigate('/profile');
        })
        .catch(() => {
          showSnackbar('There was an error while registering your COROS account. Please try again later', 'error');
          navigate('/profile');
        });
    }
  }, [location.search]);

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: window.innerHeight,
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <h1>Syncing COROS to your CoeLab account...</h1>
      <Box sx={{ width: '70%', margin: 5 }}>
        <LinearProgress />
        <LinearProgress />
        <LinearProgress />
      </Box>
    </div>
  );
};

export default CorosOAuthRedirectPage;
